import React, { useState } from "react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const NextSteps = () => {
  const [isClicked, setIsClicked] = useState(false);
  const { userSession } = useAuth(); // Get session and logout from context

  const userType = userSession?.userType;

  return (
    <main className="tw-h-screen tw-flex  tw-justify-center tw-items-center">
      <div className="tw-flex tw-flex-col tw-items-center">
        {/* SIPP Design Button */}
        {userType === "applicator" ? (
          <div>
            <Link to="/projectlist">
              <Button
                variant="default"
                size="steps"
                onClick={() => setIsClicked(true)} // Set state when clicked
              >
                <div className="tw-font-semibold">SIPP Design</div>
              </Button>
            </Link>
          </div>
        ) : (
          <div>
            <Link to="/projectinfo">
              <Button
                variant="default"
                size="steps"
                onClick={() => setIsClicked(true)} // Set state when clicked
              >
                <div className="tw-font-semibold">SIPP Design</div>
              </Button>
            </Link>
          </div>
        )}

        {/* Down arrow */}
        <div className="tw-my-2">
          <span className="tw-text-2xl tw-text-gray-500">&#x2193;</span>{" "}
          {/* Down arrow */}
        </div>

        {/* Project Estimator Button (disabled until SIPP is clicked) */}
        <div>
          <Link to="/projectestimator">
            <Button
              variant="disabled"
              size="steps"
              disabled={!isClicked} // Disable until SIPP is clicked
            >
              <div className="tw-font-semibold">Project Estimator</div>
            </Button>
          </Link>
        </div>

        {/* Down arrow */}
        <div className="tw-my-2">
          <span className="tw-text-2xl tw-text-gray-500">&#x2193;</span>{" "}
          {/* Down arrow */}
        </div>

        {/* Order the Resin Button (disabled until SIPP is clicked) */}
        <div>
          <Link to="/nextsteps">
            <Button
              variant="disabled"
              size="steps"
              disabled={!isClicked} // Disable until SIPP is clicked
            >
              <div className="tw-font-semibold">Order the Resin</div>
            </Button>
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NextSteps;
